// The first thing we say to a new account, in the rep's voice.
//
// This is a DRAFT, not a template that sends itself. The rail opens an
// outreach case and drops this in the composer; the rep edits it, flips the
// composer to the customer, and the existing review step shows it rendered
// before anything leaves. Nothing here talks to a customer.
//
// Why it is not a new email template: the customer already got the automated
// "Welcome to Squish" the moment they first signed in (squish-backend
// lib/users.js). A second system-written welcome hours later reads as a mailing
// list. This is a person writing, so it goes out the way a person's reply goes
// out — the case-reply path, "<rep> via Squish", Reply-To the rep.
//
// Written in reply markup (lib/replyMarkup.js): blank line = paragraph,
// [text](url) for links. Kept deliberately short and pitch-free.

// "Ben Howell" → "Ben", and nothing at all when the first token is not a name
// we would say out loud. Salesforce Contacts auto-provisioned from a signup
// often carry the email address as the name ("benhowelltv@gmail.com"), and
// "Hi benhowelltv@gmail.com," is worse than "Hi,". The letters-only shape is
// what rules those out — an address cannot pass it.
export function firstNameOf(name) {
  const first = String(name || '').trim().split(/\s+/)[0] || '';
  return /^[\p{L}'’-]{2,}$/u.test(first) ? first : '';
}

export function welcomeDraft({ contactName, staffName } = {}) {
  const first = firstNameOf(contactName);
  const me = String(staffName || '').trim().split(/\s+/)[0] || '';
  return [
    first ? `Hi ${first},` : 'Hi,',
    '',
    me
      ? `I'm ${me}, from Squish. Your account came through and I wanted to say hello properly rather than leave it to the automatic email.`
      : 'Your account came through and I wanted to say hello properly rather than leave it to the automatic email.',
    '',
    "If there's something you're trying to get set up, a domain, a mailbox, hosting, a whole site, reply to this and it comes straight to me.",
    '',
    'No pitch and no sequence behind this. Just glad you are here.',
    '',
    me || 'Squish',
  ].join('\n');
}
